interface SearchProps {
  onSearch?: any;
  onChange: any;
  value: string;
}

const SearchComponent = ({ onSearch, onChange, value }: SearchProps) => {

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const handleKeyPress = (e:any) => {
    // Check if the pressed key is Enter (key code 13)
    if (e.key === 'Enter') {
      // Prevent the default behavior (e.g., form submission)
      e.preventDefault();
      // Stop the event from propagating up the DOM tree
      e.stopPropagation();
    }
  };

  return (
    <input
      id="eventPlannersSearchInput"
      type="text"
      placeholder="Search"
      value={value}
      onChange={handleChange}
      className="w-[121px]"
      onKeyPress={handleKeyPress}
    />
  );
};

export default SearchComponent;
